import { Component, OnInit, Input, OnDestroy, SimpleChanges, OnChanges, Output, forwardRef, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { Relationship, RelationshipDataGroup } from '../models/UserRelationship';
import { UserRelationshipService } from '../user-relationship.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';
import { AssetGroupService } from '../asset-group.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-asset-group-dropdown',
  templateUrl: './asset-group-dropdown.component.html',
  styleUrls: ['./asset-group-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AssetGroupDropdownComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AssetGroupDropdownComponent),
      multi: true
    }
  ]
})
export class AssetGroupDropdownComponent implements OnInit, OnDestroy, OnChanges, ControlValueAccessor {

  @Input() relationship: Relationship[];
  @Input() relationshipDataGroupSelected: RelationshipDataGroup[];
  @Input() filterPlaceHolder: string;
  @Input() defaultLabel: string;
  @Input() maxSelectedLabels: number;
  @Input() group: boolean;
  @Output() onChange = new EventEmitter<RelationshipDataGroup[]>();


  subscription: Subscription;
  relationshipDataGroupByPerson: RelationshipDataGroup[];
  relationshipDataGroup: RelationshipDataGroup[];
  disabled: boolean;
  processing = false;
  items: SelectItem[];

  public onModelChange: (newValue: any) => void = () => {};
  public onModelTouched: (flag: boolean) => void = () => {};

  writeValue(value: any): void {
    this.relationship = value ?  value : this.relationship;
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
      this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  constructor(private assetGroupSvc: AssetGroupService) { }

  ngOnInit() {
    this.processing = true;
    this.subscription = this.assetGroupSvc.findByPerson()
      .subscribe((relationshipDataGroup: RelationshipDataGroup[]) => {
        this.relationshipDataGroupByPerson = [];
        this.relationshipDataGroupByPerson = (<any>relationshipDataGroup).data;
        this.filterAssetGroup(this.relationship);
        this.processing = false;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.relationship && changes.relationship.currentValue
        && changes.relationship.previousValue && this.relationshipDataGroupByPerson) {
        this.filterAssetGroup(changes.relationship.currentValue);
    }
  }

  filterAssetGroup(relationship: Relationship[]) {
    this.processing = true;
    this.relationshipDataGroup = this.relationshipDataGroupByPerson.filter((relationshipGroup: RelationshipDataGroup) =>
      relationship.map((relation) => relation.Id).indexOf(relationshipGroup.RelationshipId) !== -1
    );
    this.relationshipDataGroupSelected = this.relationshipDataGroup.filter((selectedGroup: RelationshipDataGroup) =>
      this.relationshipDataGroupSelected.map((relation) => relation.RelationshipGroupId).indexOf(selectedGroup.RelationshipGroupId) !== -1
    );
    this.items = this.generateSelectItems(this.relationshipDataGroup, relationship, this.group);
    // set timeout() is in place cause of this error "Expression has changed after it was checked"
    setTimeout(() => {
      this.onModelChange(this.relationshipDataGroupSelected);
    }, 100);
    this.processing = false;
  }

  generateSelectItems(assetGroup: RelationshipDataGroup[], relationship: Relationship[], group: boolean): SelectItem[] {
    const selectItems: SelectItem[] = [];
    if (group && assetGroup.length) {
      for (const rel of relationship) {
        selectItems.push({label: rel.RelationshipName, value: rel.RelationshipName, disabled: true});
        for (const item of assetGroup) {
          if (item.RelationshipId === rel.Id) {
            selectItems.push({label: item.RelationshipGroupName, value: item, disabled: false});
          }
        }
      }
    } else {
      for (const item of assetGroup) {
        selectItems.push({label: item.RelationshipGroupName, value: item, disabled: false});
      }
    }
    return selectItems;
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return c.value ? null : { invalidForm: {valid: false, message: 'Please select an option'}};
  }

  change(newValue: any) {
    this.onModelChange(newValue);
    this.onChange.emit(newValue);
  }

  blur() {
    this.onModelTouched(true);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
